import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.07 19.07a1 1 0 01-1.41 0l-.71-.7-.7.7a1 1 0 01-1.5-1.33l.08-.08.7-.71-.7-.7-1.42 1.4a1 1 0 01-1.49-1.32l.08-.09 1.41-1.41-3.53-3.54a1.01 1.01 0 01-.08-.1 4 4 0 111.4-1.4l.05.05 7.82 7.82a1 1 0 010 1.41zm-9.9-9.9a2 2 0 10-2.83-2.83 2 2 0 002.83 2.83z"/>
  </SvgIcon>
);